import { layout, colors } from 'src/components/base';
import styled from 'styled-components';

export const ShippingOptionList = styled.div``;

export const ShippingOptionItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${layout.measurements.spacing050};
  padding: ${layout.measurements.spacing050} 0;

  > img {
    margin-right: ${layout.measurements.spacing050};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.borderLightGray};
  }
`;

export const ItemTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;
